import axios from 'axios';
import { useShopStore } from '@/stores/shop.store';
import AccessToken from '@/services/auth';
import signature from '@/services/signature';

const ACCESS_TOKEN = AccessToken();
const BASE_URI = process.env.VUE_APP_API_BASE_URI;

let config = {
	headers: {
		Authorization: 'Bearer ' + ACCESS_TOKEN.token,
		TimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
	}
};

class POSRegistersApi {
	async list(queryString = '') {
		try {
			const response = await axios.get(BASE_URI + '/v1/pos-registers' + signature(queryString), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async getOpenShift(id) {
		try {
			const response = await axios.get(BASE_URI + '/v1/pos-registers/branches/' + id + '/open-shift' + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async openShift(id, data) {
		try {
			const response = await axios.post(BASE_URI + '/v1/pos-registers/branches/' + id + '/open-shift' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async shiftInfo(id) {
		try {
			const response = await axios.get(BASE_URI + '/v1/pos-registers/shifts/' + id + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async getCreatePayIn(id) {
		try {
			const response = await axios.get(BASE_URI + '/v1/pos-registers/shifts/' + id + '/pay-in/create' + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async createPayIn(id, data) {
		try {
			const response = await axios.post(BASE_URI + '/v1/pos-registers/shifts/' + id + '/pay-in/create' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async getCreatePayOut(id) {
		try {
			const response = await axios.get(BASE_URI + '/v1/pos-registers/shifts/' + id + '/pay-out/create' + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async createPayOut(id, data) {
		try {
			const response = await axios.post(BASE_URI + '/v1/pos-registers/shifts/' + id + '/pay-out/create' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async getCloseShift(id) {
		try {
			const response = await axios.get(BASE_URI + '/v1/pos-registers/shifts/' + id + '/close' + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async closeShift(id, data) {
		try {
			const response = await axios.post(BASE_URI + '/v1/pos-registers/shifts/' + id + '/close' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async enterShop(id) {
		try {
			const response = await axios.get(BASE_URI + '/v1/pos-registers/branches/' + id + '/shop' + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}
}

class ShiftsApi {
	async list(queryString = '') {
		try {
			const response = await axios.get(BASE_URI + '/v1/shifts' + signature(queryString), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async getInfo(id) {
		try {
			const response = await axios.get(BASE_URI + '/v1/shifts/' + id + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async getUpdate(id) {
		try {
			const response = await axios.get(BASE_URI + '/v1/shifts/' + id + '/edit' + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async update(id, data) {
		try {
			const response = await axios.put(BASE_URI + '/v1/shifts/' + id + '/edit' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	// แก้ยอดนับของกะที่ปิดแล้ว — คนละสิทธิ์กับ edit (shift_adjust)
	async getAdjust(id) {
		try {
			const response = await axios.get(BASE_URI + '/v1/shifts/' + id + '/adjust' + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async adjust(id, data) {
		try {
			const response = await axios.put(BASE_URI + '/v1/shifts/' + id + '/adjust' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}
}

class POSProductsApi {
	async list(queryString = '') {
		try {
			const response = await axios.get(BASE_URI + '/v1/pos/' + useShopStore().shiftId + '/products' + signature(queryString), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async info(id) {
		try {
			const response = await axios.get(BASE_URI + '/v1/pos/' + useShopStore().shiftId + '/products/' + id + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}
}

class POSTablesApi {
	async list(queryString = '') {
		try {
			const response = await axios.get(BASE_URI + '/v1/pos/' + useShopStore().shiftId + '/tables' + signature(queryString), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async open(id, data) {
		try {
			const response = await axios.post(BASE_URI + '/v1/pos/' + useShopStore().shiftId + '/tables/' + id + '/open' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async reserve(id, data) {
		try {
			const response = await axios.post(BASE_URI + '/v1/pos/' + useShopStore().shiftId + '/tables/' + id + '/reserve' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async cancelReserve(id) {
		try {
			const response = await axios.delete(BASE_URI + '/v1/pos/' + useShopStore().shiftId + '/tables/' + id + '/reserve' + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async getInfo(id) {
		try {
			const response = await axios.get(BASE_URI + '/v1/pos/' + useShopStore().shiftId + '/tables/' + id + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async getSummary(id) {
		try {
			const response = await axios.get(BASE_URI + '/v1/pos/' + useShopStore().shiftId + '/tables/' + id + '/summary' + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}
}

class POSSaleOrdersApi {
	async create(data) {
		try {
			const response = await axios.post(BASE_URI + '/v1/pos/' + useShopStore().shiftId + '/sale-orders' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async updateItem(orderId, itemId, data) {
		try {
			const response = await axios.put(BASE_URI + '/v1/pos/' + useShopStore().shiftId + '/sale-orders/' + orderId + '/items/' + itemId + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async deleteItem(orderId, itemId) {
		try {
			const response = await axios.delete(BASE_URI + '/v1/pos/' + useShopStore().shiftId + '/sale-orders/' + orderId + '/items/' + itemId + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async getCancelReasons(orderId, itemId) {
		try {
			const response = await axios.get(BASE_URI + '/v1/pos/' + useShopStore().shiftId + '/sale-orders/' + orderId + '/items/' + itemId + '/cancel' + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async cancelItem(orderId, itemId, data) {
		try {
			const response = await axios.put(BASE_URI + '/v1/pos/' + useShopStore().shiftId + '/sale-orders/' + orderId + '/items/' + itemId + '/cancel' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}
}

class SessionApi {
	async list(queryString = '') {
		try {
			const response = await axios.get(BASE_URI + '/v1/pos/' + useShopStore().shiftId + '/sessions' + signature(queryString), config);
			return response;
		} catch (err) {
			throw err;
		}
	}
	async open(data) {
		try {
			const response = await axios.post(BASE_URI + '/v1/pos/' + useShopStore().shiftId + '/sessions' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}
	// เปิด qr_ready session ให้หลายโต๊ะพร้อมกัน — data = { table_ids: [id,...] }
	async openBatch(data) {
		try {
			const response = await axios.post(BASE_URI + '/v1/pos/' + useShopStore().shiftId + '/sessions/open-batch' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}
	// ปิดหลาย session พร้อมกัน — data = { tokens: [token,...] }
	async closeBatch(data) {
		try {
			const response = await axios.put(BASE_URI + '/v1/pos/' + useShopStore().shiftId + '/sessions/close-batch' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}
	async getInfo(token) {
		try {
			const response = await axios.get(BASE_URI + '/v1/pos/' + useShopStore().shiftId + '/sessions/' + token + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}
	// Item-status breakdown (queued/cooking/ready/served/cancelled + totals)
	// for a session — mirrors POSTables.getSummary but keyed by session token.
	async summary(token) {
		try {
			const response = await axios.get(BASE_URI + '/v1/pos/' + useShopStore().shiftId + '/sessions/' + token + '/summary' + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}
	async products(token, queryString = '') {
		try {
			const response = await axios.get(BASE_URI + '/v1/pos/' + useShopStore().shiftId + '/sessions/' + token + '/products' + signature(queryString), config);
			return response;
		} catch (err) {
			throw err;
		}
	}
	async productInfo(token, productId) {
		try {
			const response = await axios.get(BASE_URI + '/v1/pos/' + useShopStore().shiftId + '/sessions/' + token + '/products/' + productId + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}
	async createOrder(token, data) {
		try {
			const response = await axios.post(BASE_URI + '/v1/pos/' + useShopStore().shiftId + '/sessions/' + token + '/orders' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}
	// ยกเลิกออเดอร์ platform ทั้ง session (เงินไม่มา) — is_restock ต้องอยู่ใน signed query (CONVENTIONS FE §7)
	async platformCancel(token, isRestock) {
		try {
			const response = await axios.put(BASE_URI + '/v1/pos/' + useShopStore().shiftId + '/sessions/' + token + '/platform-cancel' + signature('is_restock=' + (isRestock ? 1 : 0)), {}, config);
			return response;
		} catch (err) {
			throw err;
		}
	}
	async setCustomer(token, data) {
		try {
			const response = await axios.put(BASE_URI + '/v1/pos/' + useShopStore().shiftId + '/sessions/' + token + '/customer' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}
	// per-bill member — ผูก/ถอด member ระดับบิล (อิสระจาก session)
	async setBillCustomer(token, billId, data) {
		try {
			const response = await axios.put(BASE_URI + '/v1/pos/' + useShopStore().shiftId + '/sessions/' + token + '/bills/' + billId + '/customer' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}
	// แต้มสะสมระดับ session (ดูได้แม้ยังไม่มีบิล/ยังไม่สั่งอาหาร)
	async loyalty(token) {
		try {
			const response = await axios.get(BASE_URI + '/v1/pos/' + useShopStore().shiftId + '/sessions/' + token + '/loyalty' + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}
	// แลกแต้มตั้งแต่ยังไม่มีบิล — BE จะ find-or-create บิลให้แล้วแลก (ของแถม = order line)
	async loyaltyRedeem(token, data) {
		try {
			const response = await axios.post(BASE_URI + '/v1/pos/' + useShopStore().shiftId + '/sessions/' + token + '/loyalty/redeem' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}
	async updateItem(token, itemId, data) {
		try {
			const response = await axios.put(BASE_URI + '/v1/pos/' + useShopStore().shiftId + '/sessions/' + token + '/items/' + itemId + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async getCancelReasons(token, itemId) {
		try {
			const response = await axios.get(BASE_URI + '/v1/pos/' + useShopStore().shiftId + '/sessions/' + token + '/items/' + itemId + '/cancel' + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async cancelItem(token, itemId, data) {
		try {
			const response = await axios.put(BASE_URI + '/v1/pos/' + useShopStore().shiftId + '/sessions/' + token + '/items/' + itemId + '/cancel' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}
	async deleteItem(token, itemId) {
		try {
			const response = await axios.delete(BASE_URI + '/v1/pos/' + useShopStore().shiftId + '/sessions/' + token + '/items/' + itemId + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}
	async bills(token) {
		try {
			const response = await axios.get(BASE_URI + '/v1/pos/' + useShopStore().shiftId + '/sessions/' + token + '/bills' + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}
	async splitBill(token, billId, data) {
		try {
			const response = await axios.put(BASE_URI + '/v1/pos/' + useShopStore().shiftId + '/sessions/' + token + '/bills/' + billId + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}
	async mergeBill(token, data) {
		try {
			const response = await axios.put(BASE_URI + '/v1/pos/' + useShopStore().shiftId + '/sessions/' + token + '/bills/merge' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}
	async payBill(token, billId, data) {
		try {
			const response = await axios.put(BASE_URI + '/v1/pos/' + useShopStore().shiftId + '/sessions/' + token + '/bills/' + billId + '/payment' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}
	async close(token, data = {}) {
		try {
			const response = await axios.put(BASE_URI + '/v1/pos/' + useShopStore().shiftId + '/sessions/' + token + '/close' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}
	async moveTable(token, data) {
		try {
			const response = await axios.put(BASE_URI + '/v1/pos/' + useShopStore().shiftId + '/sessions/' + token + '/tables/move' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}
	// รายชื่อ session ที่ดึงมารวมกับ host ได้ (เปิดอยู่ + activated แล้ว) + host block
	async mergeSessionList(token) {
		try {
			const response = await axios.get(BASE_URI + '/v1/pos/' + useShopStore().shiftId + '/sessions/' + token + '/merge-sessions' + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}
	// ย้าย session ต้นทางเข้า session เจ้าบ้าน (host = token). reparent อย่างเดียว ไม่ปิด/ไม่รวมบิล
	async mergeSession(token, data) {
		try {
			const response = await axios.put(BASE_URI + '/v1/pos/' + useShopStore().shiftId + '/sessions/' + token + '/merge-sessions' + signature(), data, config);
			return response;
		} catch (err) {
			throw err;
		}
	}
}

/**
 * Staff-side service-request management for a single session.
 *
 * Counterpart of the customer-facing ServiceRequests in
 * services.service.js: the customer POSTs requests via signature-only
 * endpoints; staff acks/completes/cancels them here using the POS Bearer
 * token + the current open shift.
 *
 * All write endpoints (acknowledge/complete/cancel) accept NO body — the
 * API enforces NotAllowedRule and 422s if any key is present. We send `{}`
 * so axios still issues a PUT with Content-Type set.
 */
class SessionRequestsApi {
	async list(token, queryString = '') {
		try {
			const response = await axios.get(
				BASE_URI + '/v1/pos/' + useShopStore().shiftId + '/sessions/' + token + '/requests' + signature(queryString),
				config
			);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async acknowledge(token, requestId) {
		try {
			const response = await axios.put(
				BASE_URI + '/v1/pos/' + useShopStore().shiftId + '/sessions/' + token + '/requests/' + requestId + '/acknowledge' + signature(),
				{},
				config
			);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async complete(token, requestId) {
		try {
			const response = await axios.put(
				BASE_URI + '/v1/pos/' + useShopStore().shiftId + '/sessions/' + token + '/requests/' + requestId + '/complete' + signature(),
				{},
				config
			);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async cancel(token, requestId) {
		try {
			const response = await axios.put(
				BASE_URI + '/v1/pos/' + useShopStore().shiftId + '/sessions/' + token + '/requests/' + requestId + '/cancel' + signature(),
				{},
				config
			);
			return response;
		} catch (err) {
			throw err;
		}
	}
}

class POSReservationsApi {
	async open(reservationId) {
		try {
			const response = await axios.put(
				BASE_URI + '/v1/pos/' + useShopStore().shiftId + '/reservations/' + reservationId + '/open' + signature(),
				{},
				config
			);
			return response;
		} catch (err) {
			throw err;
		}
	}

	async cancel(reservationId) {
		try {
			const response = await axios.put(
				BASE_URI + '/v1/pos/' + useShopStore().shiftId + '/reservations/' + reservationId + '/cancel' + signature(),
				{},
				config
			);
			return response;
		} catch (err) {
			throw err;
		}
	}
}

/**
 * POS-side bills, scoped to the current open shift (useShopStore().shiftId).
 * Mirrors the back-office Bills service signatures so the bills child components
 * (OffcanvasInfo / ModalCollectPayment / ModalRefund / ModalTaxInvoice) can be
 * reused as-is. The difference is server-side: paying here credits the active
 * shift's counters (fixes the lost-session case where back-office payment doesn't).
 */
class POSBillsApi {
	base() {
		return BASE_URI + '/v1/pos/' + useShopStore().shiftId + '/bills';
	}

	async list(queryString = '') {
		try {
			return await axios.get(this.base() + signature(queryString), config);
		} catch (err) {
			throw err;
		}
	}

	async info(billId) {
		try {
			return await axios.get(this.base() + '/' + billId + signature(), config);
		} catch (err) {
			throw err;
		}
	}

	async print(billId, data = {}) {
		try {
			return await axios.post(this.base() + '/' + billId + '/print' + signature(), data, config);
		} catch (err) {
			throw err;
		}
	}

	// ออกใบกำกับภาษีเต็มรูปจากหน้า POS — ลูกค้าขอ ณ เคาน์เตอร์หลังได้สลิปแล้ว
	// (api/docs/vat-compliance.md D11) ใช้ endpoint/middleware ชุดเดียวกับหลังร้าน
	async taxInvoice(billId, data) {
		try {
			return await axios.post(this.base() + '/' + billId + '/tax-invoice' + signature(), data, config);
		} catch (err) {
			throw err;
		}
	}

	async getPayment(billId) {
		try {
			return await axios.get(this.base() + '/' + billId + '/payment' + signature(), config);
		} catch (err) {
			throw err;
		}
	}

	async payment(billId, data) {
		try {
			return await axios.post(this.base() + '/' + billId + '/payment' + signature(), data, config);
		} catch (err) {
			throw err;
		}
	}

	async void(billId, data) {
		try {
			return await axios.put(this.base() + '/' + billId + '/void' + signature(), data, config);
		} catch (err) {
			throw err;
		}
	}

	async refund(billId, data) {
		try {
			return await axios.put(this.base() + '/' + billId + '/refund' + signature(), data, config);
		} catch (err) {
			throw err;
		}
	}
}

class POSDeliveryPlatformsApi {
	// ปุ่มเลือก platform ตอนเปิด session delivery (ตัดตัวที่สาขาปิด is_active=0 แล้วจาก BE)
	async list() {
		try {
			const response = await axios.get(BASE_URI + '/v1/pos/' + useShopStore().shiftId + '/delivery-platforms' + signature(), config);
			return response;
		} catch (err) {
			throw err;
		}
	}

	// map {product_id: ราคา platform} — overlay ทับราคาหน้าร้านตอนคีย์ (docs/delivery-platform-pricing.md)
	async prices(deliveryPlatformId) {
		try {
			const qs = 'delivery_platform_id=' + deliveryPlatformId;
			const response = await axios.get(BASE_URI + '/v1/pos/' + useShopStore().shiftId + '/delivery-platforms/prices' + signature(qs), config);
			return response;
		} catch (err) {
			throw err;
		}
	}
}

export const POSRegisters = new POSRegistersApi();
export const POSBills = new POSBillsApi();
export const Shifts = new ShiftsApi();
export const POSProducts = new POSProductsApi();
export const POSTables = new POSTablesApi();
export const POSSaleOrders = new POSSaleOrdersApi();
export const Sessions = new SessionApi();
export const SessionRequests = new SessionRequestsApi();
export const POSReservations = new POSReservationsApi();
export const POSDeliveryPlatforms = new POSDeliveryPlatformsApi();
